import * as React from "react";
import PropTypes from "prop-types";
import ToggleSlider from "../components/Toggle/ToggleSlider";

// The per-kind switches, grouped. Shared by the girl's own page and the admin
// panel on her profile: the same rows, saved through a different call.
// In-site is always on and is not a choice; the switch is only "also send to
// my phone".

export default class KindSwitches extends React.Component {
	render() {
		const { groups, kinds, busyKind, onToggle, youOrHer } = this.props;
		return (
			<div className="ns-groups">
				{groups.map(group => {
					const rows = kinds.filter(k => k.group === group);
					if (!rows.length) return null;
					return (
						<div className="ns-group" key={group}>
							<h5 className="ns-group-title">{group}</h5>
							{rows.map(k => (
								<button
									type="button"
									key={k.key}
									className={"ns-row" + (k.push ? " on" : "")}
									disabled={busyKind === k.key}
									onClick={() => onToggle(k.key, !k.push)}
									title={k.push ? "Also sent to " + youOrHer + " phone. Press to keep it in the portal only." : "Portal only. Press to also send it to " + youOrHer + " phone."}
								>
									<span className="ns-row-label">{k.label}</span>
									<span className="ns-row-state">
										{k.push ? "Portal + phone" : "Portal only"} <ToggleSlider value={k.push} />
									</span>
								</button>
							))}
						</div>
					);
				})}
			</div>
		);
	}
}

KindSwitches.propTypes = {
	groups: PropTypes.arrayOf(PropTypes.string).isRequired,
	kinds: PropTypes.array.isRequired,
	busyKind: PropTypes.string,
	onToggle: PropTypes.func.isRequired,
	youOrHer: PropTypes.string.isRequired
};
